import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const f: any = function (...args: any[]) {
      f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args);
    };
    f.push = f;
    f.loaded = true;
    f.version = '2.0';
    f.queue = [];
    window.fbq = f;
    window._fbq = f;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1904779843432668');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-208">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1904779843432668&ev=PageView&noscript=1" alt="" data-id="element-209" />
    </noscript>;
}